<template>
  <article class="flex min-w-0 flex-col gap-5 rounded-xl border bg-card p-5 shadow-sm">
    <div class="flex items-start gap-3">
      <div class="rounded-lg bg-cyan-100 p-2 text-cyan-700 dark:bg-cyan-950 dark:text-cyan-300">
        <Building2 class="h-5 w-5" />
      </div>
      <div class="min-w-0 flex-1">
        <h2 class="truncate text-lg font-semibold">
          {{ company.name }}
        </h2>
        <p class="truncate text-sm text-muted-foreground">
          {{ company.startel_account_number ? `Account ${company.startel_account_number}` : 'No account number' }}
        </p>
      </div>
    </div>

    <Button class="mt-auto w-full gap-2" as-child>
      <RouterLink :to="{ name: 'HolidaysPublicCompanyPage', params: { companyUuid: company.uuid } }">
        Open company
        <ArrowRight class="h-4 w-4" />
      </RouterLink>
    </Button>
    <div class="grid auto-cols-fr grid-flow-col gap-2">
      <Button as-child variant="outline" size="sm" class="h-auto min-h-8 max-w-full whitespace-normal py-1.5 text-center">
        <RouterLink :to="{ name: 'CompanySupportRequestsPage', params: { companyUuid: company.uuid } }">
          {{ company.open_support_requests_count ?? 0 }} open support requests
        </RouterLink>
      </Button>
      <Button v-if="company.holiday_access_enabled" as-child variant="outline" size="sm" class="h-auto min-h-8 max-w-full whitespace-normal py-1.5 text-center">
        <RouterLink :to="{ name: 'CompanyHolidaysPage', params: { companyUuid: company.uuid } }">
          {{ company.unconfirmed_holiday_schedules_count ?? 0 }} holidays to confirm
        </RouterLink>
      </Button>
    </div>
  </article>
</template>

<script setup>
import { ArrowRight, Building2 } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'

defineProps({
  company: { type: Object, required: true },
})
</script>
